import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Rendered for any client-side route this phase does not define. Also what a browser sees after
 * a full page reload on an unknown client route once the host's SPA fallback serves `index.html`
 * for it — the important thing being that the fallback serves the app at all, not a bare 404.
 */
export function NotFoundPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div>
      <p>{t("session404.notFoundDescription")}</p>
      <Link className="button button-secondary" to="/">
        {t("session404.backHome")}
      </Link>
    </div>
  );
}
